/** Fecha o painel lateral do RealtimeKit (chat, enquetes, participantes, plugins). */

export type RtkUiStates = {
  activeSidebar?: boolean;
  sidebar?: string;
};

const SIDEBAR_SELECTOR = "rtk-sidebar, dyte-sidebar";
const MEETING_SELECTOR = "rtk-meeting, dyte-meeting";
const STATE_EVENTS = ["rtkStateUpdate", "dyteStateUpdate"] as const;
export const RTK_STATES_EVENTS = ["rtkStatesUpdate", "dyteStatesUpdate"] as const;

export function findRtkMeeting(root?: ParentNode | Document | null): HTMLElement | null {
  const scope = root ?? document;
  return (
    (scope.querySelector?.(MEETING_SELECTOR) as HTMLElement | null) ??
    document.querySelector(MEETING_SELECTOR)
  );
}

export function findRtkSidebar(root?: ParentNode | Document | null): HTMLElement | null {
  const scope = root ?? document;
  return (
    (scope.querySelector?.(SIDEBAR_SELECTOR) as HTMLElement | null) ??
    document.querySelector(SIDEBAR_SELECTOR)
  );
}

export function isRtkSidebarVisible(el: Element | null): boolean {
  if (!(el instanceof HTMLElement)) {
    return false;
  }
  if (el.hasAttribute("hidden") || el.getAttribute("aria-hidden") === "true") {
    return false;
  }
  const style = window.getComputedStyle(el);
  if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") {
    return false;
  }
  return el.getClientRects().length > 0;
}

export function isRtkSidebarOpen(root?: ParentNode | Document | null): boolean {
  const sidebar = findRtkSidebar(root);
  if (sidebar) {
    return isRtkSidebarVisible(sidebar);
  }
  const meetingEl = findRtkMeeting(root) as (HTMLElement & { states?: RtkUiStates }) | null;
  return Boolean(meetingEl?.states?.activeSidebar);
}

function emitClose(target: EventTarget): void {
  const detail: RtkUiStates = { activeSidebar: false, sidebar: undefined };
  for (const type of STATE_EVENTS) {
    target.dispatchEvent(new CustomEvent(type, { detail, bubbles: true, composed: true }));
  }
}

/**
 * Pede ao UI Kit para fechar o sidebar. O close nativo no celular some atrás
 * da barra Cenário/Videochamada ou é cortado pelos quatro abas do próprio RTK.
 */
export function closeRtkSidebar(root?: ParentNode | Document | null): boolean {
  const meetingEl = findRtkMeeting(root);
  const sidebar = findRtkSidebar(root);
  if (!meetingEl && !sidebar) {
    return false;
  }
  if (meetingEl) {
    emitClose(meetingEl);
  }
  if (sidebar) {
    emitClose(sidebar);
  }
  return true;
}

export function readActiveSidebarFromEvent(event: Event): boolean | undefined {
  const detail = (event as CustomEvent<RtkUiStates | undefined>).detail;
  if (!detail || typeof detail.activeSidebar !== "boolean") {
    return undefined;
  }
  return detail.activeSidebar;
}
